module.exports = __webpack_public_path__ + "static/media/matt.ac081eb4.JPG";